import React, { useEffect, useState, useRef } from 'react'
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined, ExclamationCircleFilled, RightOutlined, LeftOutlined } from '@ant-design/icons';
import { Table, Empty, Form, Divider, Button, message, Space, Skeleton } from 'antd';
import { procesarPreNomina, getDetallePreNomina, getEncabezadoPreNomina } from '../../../../apis/ProcesoPreNominaApi';
import AnioPreNomina from '../../../../components/forms/anio_prenomina';
import Currency from '../../../../components/common/Currency';
import useCookies from "../../../../hooks/useCookies";
import { status_period } from '@app/constants/period';
import { clases } from '../../../../constants/tipoConcepto';
import FormBody from './form'
import _ from 'lodash'
import './slytes.scss';

const routes = [{
  href: '',
  title: <>
    <HomeOutlined />
    <span>Inicio</span>
  </>,
},
{
  href: '',
  title: (
    <>
      <UnorderedListOutlined />
      <span>Asistencia</span>
    </>
  ),
},
{
  href: '',
  title: (
    <>
      <UnorderedListOutlined />
      <span>Procesos</span>
    </>
  ),
},
{
  href: '',
  title: (
    <>
      <UnorderedListOutlined />
      <span>Pre-Nómina Individual</span>
    </>
  ),
}];

const ProcesarPreNomina = () => {
  const [empleadoCookie] = useCookies("empleado_id");
  const [form] = Form.useForm()
  const [result, setResult] = useState([]);
  const [periodDetail, setPeriodDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [objectSelected, setObjectSelected] = useState(null);
  const [disabledForm, setDisabled] = useState(true);
  const [periodData, setPeriodData] = useState(null);
  const [status, setStatus] = useState(null);
  const [extrasExpanded, setExtrasExpanded] = useState(false);
  const [tipoDiaExpanded, setTipoDiaExpanded] = useState(false);
  const [header, setHeader] = useState(null);
  const bodyRef = useRef(null);
  const anioPrenominaRef = useRef(null);

  useEffect(() => {
    (async () => {
      if (empleadoCookie?.value > 0) {
        var _header = { ...header, odoo_empleado_id: empleadoCookie?.value };
        setHeader(_header)
      }
    })();
  }, [empleadoCookie]);

  const handleOkEmpleado = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      if (!values) return;
      const payload = { ...values }
      const response = await procesarPreNomina(payload);
      if (!response.ok) {
        message.error('Error al procesar la pre-nómina');
        setLoading(false);
        return;
      }
      message.success('Se proceso correctamente la pre-nómina!');

      const [detalleRes, encabezadoRes] = await Promise.all([
        getDetallePreNomina(values.periodo_id, values.anio, values.num_periodo, values.odoo_empleado_id),
        getEncabezadoPreNomina(values.periodo_id, values.anio, values.num_periodo, values.odoo_empleado_id)
      ]);
      if (detalleRes.ok) setResult(detalleRes.payload);
      if (encabezadoRes.ok && encabezadoRes.payload) {
        bodyRef.current?.updateEncabezado?.(encabezadoRes.payload);
      }

      setLoading(false);
      await anioPrenominaRef.current?.refreshStatus?.();
    } catch (errorInfo) {
      console.log('Failed:', errorInfo);
      setLoading(false);
    }
  }

  const handleChangeEmpleado = async () => {
    try {
      const values = await form.validateFields();
      if (!values) return;
    } catch (errorInfo) {
      console.log('Failed:', errorInfo);
      return;
    }

    setLoading(true);

    try {
      const fields = form.getFieldsValue();
      const payload = {
        periodo_id: fields.periodo_id,
        anio: fields.anio,
        num_periodo: fields.num_periodo,
        odoo_empleado_id: fields.odoo_empleado_id
      }

      const response = await getDetallePreNomina(
        payload.periodo_id,
        payload.anio,
        payload.num_periodo,
        payload.odoo_empleado_id
      );

      if (response.ok) {
        setResult(response.payload);
      } else {
        message.error('Error al cargar los detalles de prenómina');
        setResult([]);
      }
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al cargar los detalles de prenómina');
      setResult([]);
    } finally {
      setLoading(false);
    }
  }

  const onBlurHeader = async (values, dataPeriod, status) => {
    setHeader(values)
    if (values?.anio && values?.num_periodo && values?.periodo_id) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
    setPeriodData(dataPeriod);
    setStatus(status?.value);
  }

  const getPeriodDetails = async (periodDetails) => {
    setPeriodDetail(periodDetails);
  }

  const renderNum = (item) => {
    if (item === null || item === undefined || item === '') return '';
    const n = Math.abs(Number(item) || 0);
    if (n === 0) return '';
    return n.toFixed(2);
  };

  const getDayName = (dateStr) => {
    if (!dateStr) return '';
    const [day, month, year] = dateStr.split('/');
    const date = new Date(+year, +month - 1, +day);
    return ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'][date.getDay()];
  };

  const toggleExtras = () => setExtrasExpanded(prev => !prev);
  const toggleTipoDia = () => setTipoDiaExpanded(prev => !prev);

  const renderHorasExtras = (text, record) => {
    const val = renderNum(text);
    const extras = Number(text) || 0;
    const validadas = Number(record.validated_overtime_hours) || 0;
    const noValidadas = extras > 0 && validadas < extras;
    return noValidadas ? <span style={{ color: 'red' }}>{val}</span> : val;
  };

  const extrasCol = {
    title: <span onClick={toggleExtras} style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}>
      Horas Extras {extrasExpanded ? <LeftOutlined /> : <RightOutlined />}
    </span>,
    dataIndex: 'horas_extras',
    key: 'horas_extras',
    align: 'right',
    width: 150,
    render: renderHorasExtras,
  };

  const dobleCol = {
    title: 'Dobles',
    dataIndex: 'extras_doble',
    key: 'extras_doble',
    align: 'right',
    width: 90,
    render: renderNum,
  };

  const tripleCol = {
    title: 'Triples',
    dataIndex: 'extras_triple',
    key: 'extras_triple',
    align: 'right',
    width: 90,
    render: renderNum,
  };

  const validadasCol = {
    title: 'Validadas',
    dataIndex: 'validated_overtime_hours',
    key: 'validated_overtime_hours',
    align: 'right',
    width: 90,
    render: renderNum,
  };

  const diaCol = {
    title: 'Día Semana',
    dataIndex: 'fecha',
    key: 'dia_semana',
    width: 100,
    render: getDayName,
  };

  const baseColumns = [
    {
      title: <span onClick={toggleTipoDia} style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}>
        Tipo Día {tipoDiaExpanded ? <LeftOutlined /> : <RightOutlined />}
      </span>,
      dataIndex: 'tipo_dia',
      key: 'tipo_dia',
      width: 100,
    },
    ...(tipoDiaExpanded ? [diaCol] : []),
    {
      title: 'Permiso',
      dataIndex: 'permiso_nombre',
      key: 'permiso_nombre',
      width: 180,
    },
    {
      title: 'Entrada',
      dataIndex: 'entrada',
      key: 'entrada',
      width: 150,
    },
    {
      title: 'Salida',
      dataIndex: 'salida',
      key: 'salida',
      width: 150,
    },
    {
      title: 'Horas Trabajadas',
      dataIndex: 'horas_trabajadas',
      key: 'horas_trabajadas',
      align: 'right',
      width: 110,
      render: renderNum,
    },
    extrasCol,
    ...(extrasExpanded ? [validadasCol, dobleCol, tripleCol] : []),
    {
      title: 'Descanso Trabajado',
      dataIndex: 'descanso_trabajado',
      key: 'descanso_trabajado',
      align: 'right',
      width: 100,
      render: renderNum,
    },
    {
      title: 'Festivo Trabajado',
      dataIndex: 'festivo_trabajado',
      key: 'festivo_trabajado',
      align: 'right',
      width: 100,
      render: renderNum,
    },
    {
      title: 'Falta',
      dataIndex: 'falta',
      key: 'falta',
      align: 'right',
      width: 80,
      render: renderNum,
    },
    {
      title: 'Retardo',
      dataIndex: 'retardo',
      key: 'retardo',
      align: 'right',
      width: 80,
      render: renderNum,
    },
    {
      title: 'Permiso c/g',
      dataIndex: 'permiso_cg',
      key: 'permiso_cg',
      align: 'right',
      width: 100,
      render: renderNum,
    },
    {
      title: 'Permiso s/g',
      dataIndex: 'permiso_sg',
      key: 'permiso_sg',
      align: 'right',
      width: 100,
      render: renderNum,
    },
    {
      title: 'Horario',
      dataIndex: 'horario_nombre',
      key: 'horario_nombre',
      width: 200,
    },
  ];

  return <PageApp
    routes={routes}
    title={'Procesar Pre-Nómina Individual'}>
    <AnioPreNomina ref={anioPrenominaRef} onBlur={onBlurHeader} getPeriodDetails={getPeriodDetails} form={form} disabledForm={objectSelected && objectSelected.id > 0} />
    <Divider />
    {
      periodData && <FormBody header={header} ref={bodyRef} onOk={handleOkEmpleado} onChangeEmpleado={handleChangeEmpleado} form={form} disabledForm={disabledForm} disabledSubmit={status && (status > status_period.calculado_total)} />
    }
    <Divider />
    {
      loading ? <Skeleton active={loading} /> : <>
        {
          result.length == 0 ? <Empty /> :
            <Table
              dataSource={result}
              columns={baseColumns}
              pagination={false}
              scroll={{ x: (extrasExpanded ? 2200 : 1800) + (tipoDiaExpanded ? 110 : 0) }}
              size="small"
            />
        }
      </>
    }
  </PageApp>
}

export default ProcesarPreNomina;